import axios from 'axios';
import { MDBFileUpload } from 'mdb-react-file-upload';
import { MDBAlert, MDBBtn, MDBCol, MDBContainer, MDBRow, MDBSpinner, MDBTypography } from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { DomainContext } from '../context/DomainProvider';
import { MiscContext } from '../context/MiscProvider';
import { UserProfileContext } from '../context/UserProfileProvider';
import { fetchCompanyMap, fetchDocumentMap } from "./../../components/utils/Common";

const Upload = ({ setReceipts, entitiesCreated, documentType,onImageUpload }) => {
  const baseUrl = process.env.REACT_APP_INVENTORY_URL;
  const [stackingAlertsContainer, setStackingAlertsContainer] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [scannedFiles, setScannedFiles] = useState([]);
  const [isUploadDisabled, setIsUploadDisabled] = useState(true);
  const [alert, setAlert] = useState(false);
  const stackingContainer = useRef(null);
  const { domainId } = useParams();
  const navigate = useNavigate();
  const [type, setType] = useState(documentType);
  const { setCompaniesMap, setDocumentsMap, isUploading, setIsUploading } = useContext(MiscContext);
  const { domainData } = useContext(DomainContext);
  const { tokenLoaded } = useContext(UserProfileContext);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [capturedImage, setCapturedImage] = useState(null);
  const [facingMode, setFacingMode] = useState('environment');

  useEffect(() => {
    setIsUploadDisabled(!selectedFiles.length && !scannedFiles.length);
  }, [selectedFiles, scannedFiles]);

  const getContentType = (filename) => {
    const extension = filename.split('.').pop().toLowerCase();
    switch (extension) {
      case 'pdf':
        return 'application/pdf';
      case 'png':
        return 'image/png';
      case 'jpeg':
      case 'jpg':
        return 'image/jpeg';
      case 'gif':
        return 'image/gif';
      default:
        return '';
    }
  };

  const startCamera = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode } });
      videoRef.current.srcObject = stream;
    } catch (err) {
      console.error("Error accessing camera: ", err);
    }
  };

  const captureImage = () => {
    const context = canvasRef.current.getContext('2d', { willReadFrequently: true });
    context.drawImage(videoRef.current, 0, 0, canvasRef.current.width, canvasRef.current.height);
    const dataUrl = canvasRef.current.toDataURL('image/png');
    setCapturedImage(dataUrl);
    fetch(dataUrl)
      .then(res => res.blob())
      .then(blob => {
        const file = new File([blob], 'captured_image.png', { type: 'image/png' });
        setScannedFiles([...scannedFiles, file]);
      });
  };

  const handleUpload = async () => {
    if (!selectedFiles.length && !scannedFiles.length) {
      setAlert(true);
      return;
    }
    setAlert(false);
    setIsUploading(true);

    const filesToUpload = [...selectedFiles, ...scannedFiles];

    for (let file of filesToUpload) {
      const formData = new FormData();
      formData.append('files', file);
      formData.append('type', type);
      const contentType = getContentType(file.name);

      try {
        const endpoint = `${baseUrl}/imgs/receipt?type=${documentType}`;
        const response = await axios.post(endpoint, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'contentForImageProcess': contentType
          },
          withCredentials: true,
        });

        if (response.status === 200 || response.status === 201) {
          await fetchCompanyMap(setCompaniesMap, tokenLoaded);
          await fetchDocumentMap(setDocumentsMap, tokenLoaded);
          setReceipts && setReceipts(prevReceipts => [...prevReceipts, ...response.data]);
  if(!onImageUpload)  {
            navigate(`/unProcessed/${type}`);
  }
          showAlert(file.name, 'success');
          const imageUrl = response.data[0].url; // Assuming the API returns the URL in this format
        if (onImageUpload) {
          onImageUpload(imageUrl); // Call the parent function to set the image URL
        }
        } else {
          showAlert(file.name, 'error');
        }
      } catch (error) {
        if (error.message.includes('413')) {
          showAlert('Should be less than 3M', 'Should be less than 3M');
        } else {
          showAlert(file.name, 'error');
        }
      } finally {
        setAlert(false);
      }
    }
    setIsUploading(false);
    setSelectedFiles([]);
    setScannedFiles([]);
  };

  const handleFileSelect = (event) => {
    if (event) {
      setSelectedFiles(Array.from(event));
    }
  };

  const showAlert = (fileName, status) => {
    let color;
    let message;

    if (status === 'success') {
      color = 'success';
      message = `${fileName} uploaded successfully!`;
    } else {
      color = 'danger';
      message = `Error while uploading ${fileName}!`;
    }

    const ID = Math.random().toString();

    setStackingAlertsContainer([
      ...stackingAlertsContainer,
      {
        color: color,
        message: message,
        visible: true,
        id: ID,
      },
    ]);
  };

  const handleCloseStackingContainerClick = (id) => {
    const tempStackingContainerAlerts = stackingAlertsContainer.filter(alert => alert.id !== id);
    setStackingAlertsContainer(tempStackingContainerAlerts);
  };

  const handleRemoveSelectedFile = (index) => {
    setSelectedFiles(selectedFiles.filter((_, i) => i !== index));
  };

  const handleRemoveScannedFile = (index) => {
    setScannedFiles(scannedFiles.filter((_, i) => i !== index));
  };

  const toggleFacingMode = () => {
    setFacingMode(prevMode => (prevMode === 'environment' ? 'user' : 'environment'));
    startCamera();
  };

  return (
    <MDBContainer className="d-flex justify-content-center" style={{ display: 'flex', flexDirection: 'column-reverse' }} ref={stackingContainer}>
      <MDBRow className='d-flex justify-content-between'>
        <MDBCol  className='text-center '>
       
          <MDBTypography  variant="h2" className="mt-2 mb-3 display-6 fw-bold" color='primary'>
            {`Upload ${type} Documents`}
          </MDBTypography>
          <MDBFileUpload 
  multiple 
  className='text-center bg-white bg-gradient text-dark rounded-5 lin-success mb-2 mt-2'
  //defaultMessage={`Please Upload ${type} documents`}
  onChange={handleFileSelect}
/>

         <canvas ref={canvasRef} width="300" height="200" style={{ display: 'none' }}></canvas>
         {selectedFiles.length !== 0 &&  <MDBBtn  block color='black' onClick={!isUploading ? handleUpload : undefined} className=" mt-2" type='button'>
              {isUploading ? (
                <MDBSpinner className='mx-2' color='light'>
                  <span className='visually-hidden'>Loading...</span>
                </MDBSpinner>
              ) : (
                'Upload'
              )}
            </MDBBtn>}
        </MDBCol>
        {/* <MDBCol md="6" className='text-center'>

        
          <MDBTypography variant="h2" className="mt-2 mb-3 display-6 fw-bold" color='primary'>
            Scan Images
          </MDBTypography>
          <div id="scanner-container">
            <video ref={videoRef} style={{ width: '100%', height: '300px' }} autoPlay></video>
          </div>
          <div className="mt-2">
            <MDBBtn onClick={startCamera} className='me-2 mb-2' color='black'>Start Camera</MDBBtn>
            <MDBBtn onClick={captureImage} className='mb-2 me-2' color='success'>Capture Image</MDBBtn>
            <MDBBtn onClick={toggleFacingMode} className='mb-2' color='info'>Toggle Camera</MDBBtn>
          </div>
          <canvas ref={canvasRef} width="300" height="200" style={{ display: 'none' }}></canvas>
          <div className='mt-2'>
          {scannedFiles.map((file, index) => (
              <div key={index} className="thumbnail-wrapper">
                <img
                  src={URL.createObjectURL(file)}
                  alt={`Scanned file ${index}`}
                  className="thumbnail-preview"
                />
                <MDBBtn size='sm' className='thumbnail-remove' color='danger' onClick={() => handleRemoveScannedFile(index)}>Remove</MDBBtn>
              </div>
            ))}
          </div>
        </MDBCol> */}
       {/*  <MDBCol md="4" className='text-center '>
        <DocumentScanner />
        </MDBCol> */}
      </MDBRow>
      {/* {selectedFiles.length !== 0 && (
        <MDBRow className='text-center d-flex justify-content-center'>
          <MDBCol className='text-center'>
            <MDBRow>
            <MDBBtnGroup className='mb-2  text-center d-flex justify-content-center'>
              <MDBRadio  btnColor='warning' id='btn-Invoice' name='options' wrapperTag='span' label='Invoice' onClick={() => setType('invoice')} />
              <MDBRadio   btnColor='success'   id='btn-Receipt'   name='options'  wrapperClass='mx-2'   wrapperTag='span' label='Receipt'  defaultChecked={type === 'receipt'} onClick={() => setType({type})}   />
              <MDBRadio  btnColor='primary' id='btn-Bill' name='options' wrapperTag='span' label='Bill' wrapperClass='mx-2' defaultChecked={type === 'bill'} onClick={() => setType({type})} />
              <MDBRadio  btnColor='black' id='btn-title' name='options' wrapperTag='span' label='Title' wrapperClass='mx-2' defaultChecked={type === 'title'} onClick={() => setType({type})} />
              <MDBRadio  btnColor='secondary' id='btn-Other' name='options' wrapperTag='span' label='Other' defaultChecked={type === 'other'} onClick={() => setType({type})} />
            </MDBBtnGroup>
            </MDBRow>
            <MDBRow>
           
            </MDBRow>
          </MDBCol>
          
        </MDBRow>
      )} */}
      <MDBAlert open={alert} className='mt-3 w-100' color='primary'>
        Please select files to upload by clicking Choose Files.
      </MDBAlert>
      {stackingAlertsContainer.map((item) => (
        <MDBAlert
          className='d-flex justify-content-between'
          color={item.color}
          stacking="true"
          offset={10}
          autohide
          width={250}
          position='top-right'
          delay={5000}
          open={item.visible}
          containerRef={stackingContainer}
          key={item.id}
        >
          <p className='mb-0'>{item.message}</p>
          <MDBBtn
            className='btn-close'
            noRipple
            outline
            color='none' type='button'
            onClick={() => handleCloseStackingContainerClick(item.id)}
          />
        </MDBAlert>
      ))}

    </MDBContainer>
  );
};

Upload.propTypes = {
  documentType: PropTypes.string,
  setReceipts: PropTypes.func,
  entitiesCreated: PropTypes.bool,
  onImageUpload: PropTypes.func,
};

export default Upload;
